import { render, staticRenderFns } from "./Clasy.vue?vue&type=template&id=8b532900&scoped=true"
import script from "./Clasy.vue?vue&type=script&lang=js"
export * from "./Clasy.vue?vue&type=script&lang=js"
import style0 from "./Clasy.vue?vue&type=style&index=0&id=8b532900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b532900",
  null
  
)

export default component.exports